import { zdarKidsCustomCiphers } from '../zdarKidsGameCustomCiphers';
import audio from '../../../../assets/audio/kids-tracks/Text18.mp3';

export const step24bridge = {
    id: 24,
    title: 'Most',
    taskText: `
        <p>
            Už z dálky na nás ten jeho brácha mával. Ty jo, ten ale rychle mluví. Pořád opakuje, jak moc ho mrzí, 
            že to dřevo s bratrem ukradli a pohádali se kvůli tomu. Prosí nás, abychom ho osvobodili a 
            on se s ním mohl zase udobřit. Za odměnu nás pustí dál. 
        </p>
        <p>
            Od nás chce vědět, koho všeho už jsme po cestě potkali.
        </p>
    `,
    cipher: {
        custom: zdarKidsCustomCiphers.bridge,
        label: 'Úkol',
    },
    continueButtonText: 'Pokračovat',
    points: true,
    audio: audio,
    hints: [
        {
            text: 'Potkali sme upíra Ulricha, mušketýra se psem, dřevorubce a pani hraběnku.',
        },
    ],
};
